/** @module Sourcing/AdoptSupplierItemToStyleForm */
define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "csi",
    "csi/comm",
    "csi/comm/PostRequest",
    "csi/def",
    "csi/def/Action",
    "csi/def/Field",
    "csi/def/Parameter",
    "csi/def/Relationship",
    "csi/def/Request",
    "csi/def/ViewRef",
    "csi/form/Widget",
    "csi/locale",
    "csi/xml",
    "csi/xml/Query",
    "Apparel/NewStyleForm"
], function(declare,lang,csi,comm,PostRequest,def,Action,Field,Parameter,Relationship,Request,ViewRef,Widget,locale,xml,Query,NewStyleForm) {

    // Path from this SupplierItem to the Inspiration Style
    var PATH_INSPIRATION_STYLE = "Child:__Parent__/Child:__Parent__/Child:__Parent__";

    // Path from this SupplierItem to the SupplierRequest
    var PATH_SUPPLIER_REQUEST = "Child:QuoteSRLineItem/Child:__Parent__";

    return declare(NewStyleForm, {
        FIELD_PARENT_SEASON : "ParentSeason",
        FIELD_CATEGORY1 : "Category1",
        FIELD_CATEGORY2 : "Category2",
        FIELD_COLLECTION : "Collection",

	    FIELD_THEME : "Theme",

	    STYLE_COPY_TEMPLATE : "StyleCopyTemplate",


        bAddHierarchyFields : true,

        // Parent Inspiration Style of the current SupplierItem
        _srLineItem : null,

	    // Current SupplierItem node
	    _supplierItem : null,

	    /**
	     * add Style Copy Template Field
	     */
	    _addStyleCopyTemplateField: function(srLineItem) {
            this.insertField(lang.mixin(new Field(), {
                m_label: locale.resource(this.STYLE_COPY_TEMPLATE),
                idParameter: this.STYLE_COPY_TEMPLATE,
                m_typeControl: def.FIELD_FILTERING_SELECT,
                m_bRequired: true,
                // query as system for style copy templates for adopt supplier item to style action
                // the agent in Big Lots customer won't have access to inspiration style
                // therefore style type needs to be found as system on a server
                m_relationship : lang.mixin(new Relationship(), {
                    m_typeNode : "StyleCopyOptions",
                    m_module: "Sourcing",
                    m_operation: "GetAdoptSupplierItemToStyleCopyOptions",
                    m_parameters:
                        {
                            "URL": srLineItem.$URL
                        }
                })
            }), xml.ATTR_NAME);
        },

        _getSRLineItem:function() {
            if(!this._srLineItem) {
                this._srLineItem  = this.cacheView.getNode(this._supplierItem.QuoteSRLineItem);
            }

            return this._srLineItem;
        },

        /**
         * summary: return request used to query for root object of view with dependencies
         * @param {Node} - node
         * @return {Request}
         */
        _getRootRequest: function(node) {
            this._supplierItem = this.getViewNode() || this.defView.getSourceNode();

            var req = this.inherited(arguments) || new PostRequest(comm.MOD_SEARCH, comm.OP_URL);
            req.addParameter(comm.QUERY_URL, [this._supplierItem.$URL], true);
            req.addDependencyPaths([PATH_INSPIRATION_STYLE, PATH_SUPPLIER_REQUEST]);

            return req;
        },

        /**
         * Set fields' default values
         */
        _buildView: function() {
            if(!this._supplierItem) {
                this._supplierItem = this.getViewNode() || this.defView.getSource().getParent();
            }

            if (this._supplierItem) {
                // Name field : use inspiration style's name as default
                var srLineItem = this._getSRLineItem();
                if (srLineItem) {
                    this.addDefaultValue(xml.ATTR_NAME, this._supplierItem.$Name);

                    this._addStyleCopyTemplateField(srLineItem);
                }

                // If SupplierRequest is created under a Season hierarchy, set default to Collection field same as the parent SR hiearchy
                var supplierRequest = this.cacheView.getPathNode(this._supplierItem, PATH_SUPPLIER_REQUEST);
                if (supplierRequest){
                    // If SupplierRequest is created under a StructureItem node
                    if (xml.isValidURL(supplierRequest.SRSeason)) {
                        this.addDefaultValue(this.FIELD_PARENT_SEASON, supplierRequest.SRSeason);
                    }
                    if (xml.isValidURL(supplierRequest.SRCategory1)) {
                        this.addDefaultValue(this.FIELD_CATEGORY1, supplierRequest.SRCategory1);
                    }
                    if (xml.isValidURL(supplierRequest.SRCategory2)) {
                        this.addDefaultValue(this.FIELD_CATEGORY2, supplierRequest.SRCategory2);
                    }
                    if (xml.isValidURL(supplierRequest.SRCollection)) {
                        this.addDefaultValue(this.FIELD_COLLECTION, supplierRequest.SRCollection);
                    }
                }
            }

            this.inherited(arguments);
        },

        /**
         * Hide the "Theme" field if it is added (example: by BO FormDefinition)
         */
        _resolveView: function() {
            this.inherited(arguments);

            this.defView.removeField(this.FIELD_THEME);
            this.defView.removeField("Template");
            this.defView.removeField("ProductType");
        }
    });
});